// 根据id和类型返回一个树节点数据
export const findTreeItemData = (id, type, treeData) => {
  if (treeData.length === 0) return null
  for (let i = 0; i < treeData.length; i++) {
    if (treeData[i].id === id && treeData[i].type === type) {
      return treeData[i]
    }
    if (treeData[i].children.length !== 0) {
      let treeItemData = findTreeItemData(id, type, treeData[i].children)
      if (treeItemData !== null) {
        return treeItemData
      }
    }
  }
  return null
}

// 更新树节点图标
export const updateTreeItemIcon = (id, type, treeData, icon) => {
  for (let i = 0; i < treeData.length; i++) {
    let treeItemData = treeData[i]
    if (treeItemData.type === type && treeItemData.id === id) {
      treeItemData.slots.icon = icon
      return true
    }

    if (treeData[i].children.length !== 0) {
      if (updateTreeItemIcon(id, type, treeData[i].children, icon)) {
        return true
      }
    }
  }

  return false
}

// 根据名称搜索树,返回结果树数据
export const searchTreeByTitle = (key, treeData) => {
  let resultTreeData = []
  return _searchTreeByTitle(key, treeData, resultTreeData)
}

const _searchTreeByTitle = (key, treeData, resultTreeData) => {
  if (treeData.length === 0) return

  for (let i = 0; i < treeData.length; i++) {
    if (treeData[i].name.indexOf(key) !== -1) {
      resultTreeData.push(treeData[i])
    }
    if (treeData[i].children.length !== 0) {
      _searchTreeByTitle(key, treeData[i].children, resultTreeData)
    }
  }
  return resultTreeData
}

/**********************************************************************************************************/
// 针对业务功能实现
/**********************************************************************************************************/
// 加载区域树
export const loadRegionTree = (records, treeData, showStreamNodeCount) => {
  treeData = []
  records.forEach(function (record) {
    if (record.parentRegionId === 0) {
      treeData.push(toRegionTreeItemData(record, showStreamNodeCount))
    }
  })
  if (treeData.length > 0) {
    loadRegionTreeItems(records, treeData[0], showStreamNodeCount)
  }
  return treeData
}

// 区域记录转为树节点数据
const toRegionTreeItemData = (record, showStreamNodeCount) => {
  return {
    key: 'region' + record.id,
    label: record.name + String(showStreamNodeCount ? '(' + (record.streamNodeCount - record.streamNodeOfflineCount) + '/' + record.streamNodeCount + ')' : ''),
    name: record.name + String(showStreamNodeCount ? '(' + (record.streamNodeCount - record.streamNodeOfflineCount) + '/' + record.streamNodeCount + ')' : ''), // 自定义字段
    id: record.id, // 自定义字段
    children: [],
    slots: {
      icon: 'region'
    },
    type: 'region' // 自定义字段
  }
}

// 加载区域树区域节点
const loadRegionTreeItems = (records, parentTreeItemData, showStreamNodeCount) => {
  let childrens = []
  for (let j = 0; j < records.length; j++) {
    let record = records[j]
    if (parentTreeItemData.id === record.parentRegionId) { // 判断是否为儿子节点
      childrens.push(toRegionTreeItemData(record, showStreamNodeCount))
    }
  }
  parentTreeItemData.children = childrens

  // 递归加载
  for (let j = 0; j < childrens.length; j++) {
    loadRegionTreeItems(records, childrens[j], showStreamNodeCount)
  }

  return parentTreeItemData
}

// 视频节点记录转为树节点数据
const toStreamNodeTreeItemData = (record) => {
  return {
    key: 'streamNode' + record.id,
    label: record.name,
    name: record.name, // 自定义字段
    id: record.id, // 自定义字段
    children: [],
    streamOpenMode: record.streamOpenMode,
    alarmState: record.alarmState, // 0-正常，1-告警，2-未知
    eventTypeSet: record.eventTypeSet,
    streamObjectKind: record.streamObjectKind,
    streamServerIp: record.streamServerIp,
    streamServerPort: record.streamServerPort,
    streamServerPort2: record.streamServerPort2,
    streamServerPort3: record.streamServerPort3, // 端口3为rtmp/hls/flv端口
    streamServerPort4: record.streamServerPort4,
    workState: 0, // 0-关闭，1-打开
    slots: {
      icon: 'close'
    },
    type: 'streamNode' // 自定义字段
  }
}

// 加载区域树视频节点
export const loadStreamNodeTreeItems = (records, treeData) => {
  let regionTreeItemData = null
  for (let j = 0; j < records.length; j++) {
    let record = records[j]
    if (regionTreeItemData === null) {
      regionTreeItemData = findTreeItemData(record.regionId, 'region', treeData)
    }
    if (regionTreeItemData !== null) {
      regionTreeItemData.children.push(toStreamNodeTreeItemData(record))
    }
  }

  return treeData
}

// 加载视频节点树视频节点(不包含区域节点）
export const loadStreamNodeTreeItemsWithoutRegion = (records, treeData) => {
  // 构建一个虚拟的区域节点
  let regionTreeItemData = toRegionTreeItemData({
    name: '全部节点',
    id: 0,
    slots: {
      icon: 'region'
    },
    type: 'region'
  })

  for (let j = 0; j < records.length; j++) {
    let record = records[j]
    regionTreeItemData.children.push(toStreamNodeTreeItemData(record))
  }
  treeData.push(regionTreeItemData)

  return treeData
}

// 数据节点记录转为树节点数据
const toDataNodeTreeItemData = (record) => {
  return {
    key: 'dataNode' + record.id,
    label: record.name,
    name: record.name, // 自定义字段
    id: record.id, // 自定义字段
    children: [],
    alarmState: record.alarmState, // 0-正常，1-告警，2-未知
    eventTypeSet: record.eventTypeSet,
    gaugedObjectKind: record.gaugedObjectKind,
    realValue: 0,
    slots: {
      icon: 'close'
    },
    type: 'dataNode' // 自定义字段
  }
}

// 加载区域树数据节点
export const loadDataNodeTreeItems = (records, treeData) => {
  let regionTreeItemData = null
  for (let j = 0; j < records.length; j++) {
    let record = records[j]
    if (regionTreeItemData === null) {
      regionTreeItemData = findTreeItemData(record.regionId, 'region', treeData)
    }
    if (regionTreeItemData !== null) {
      regionTreeItemData.children.push(toDataNodeTreeItemData(record))
    }
  }

  return treeData
}

// 监控子设备记录转为树节点数据
const toAuxMonitoringDeviceTreeItemData = (record) => {
  return {
    key: 'auxMonitoringDevice' + record.id,
    label: record.name,
    name: record.name, // 自定义字段
    id: record.id, // 自定义字段
    children: [],
    alarmState: record.alarmState, // 0-正常，1-告警，2-未知
    eventTypeSet: record.eventTypeSet,
    resourceSubType: record.resourceSubType,
    workState: 0, // 0-关闭，1-打开
    slots: {
      icon: 'close'
    },
    type: 'auxMonitoringDevice' // 自定义字段
  }
}

// 加载区域树监控子设备
export const loadAuxMonitoringDeviceTreeItems = (records, treeData) => {
  let regionTreeItemData = null
  for (let j = 0; j < records.length; j++) {
    let record = records[j]
    if (regionTreeItemData === null) {
      regionTreeItemData = findTreeItemData(record.regionId, 'region', treeData)
    }
    if (regionTreeItemData !== null) {
      regionTreeItemData.children.push(toAuxMonitoringDeviceTreeItemData(record))
    }
  }

  return treeData
}



// WEBPACK FOOTER //
// ./src/utils/tree.js